import { useState } from "react";
import useDebounce from "../../util/useDebounce";
import { useQuery } from "@tanstack/react-query";
import { searchGarantLaws } from "../../api";
import {
  TextField,
  List,
  ListItem,
  ListItemText,
  Paper,
  Box,
} from "@mui/material";

export const SearchDropdown = ({ onSelect }: { onSelect: (topic: number) => void }) => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const debouncedSearch = useDebounce(search, 300);

  const {
    data: searchData,
    error: searchError,
    isLoading: searchLoading,
  } = useQuery({
    queryKey: ["garant", "search", debouncedSearch],
    queryFn: () => searchGarantLaws(debouncedSearch),
    enabled: debouncedSearch?.length > 0,
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setIsOpen(e.target.value.length > 0);
  };

  const handleItemClick = (item: any) => {
    setIsOpen(false);
    onSelect(item.topic);
  };

  const handleBlur = () => {
    // Delay closing to allow for clicks on dropdown items
    setTimeout(() => setIsOpen(false), 200);
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        label="Поиск"
        value={search}
        onChange={handleSearchChange}
        onFocus={() => search.length > 0 && setIsOpen(true)}
        onBlur={handleBlur}
        fullWidth
      />
      {isOpen && searchData && searchData.documents.length === 0 && (
        <Paper
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: 300,
            overflow: "auto",
            mt: 1,
            boxShadow: 3,
            p: 2,
          }}
        >
          <ListItemText primary="Ничего не найдено" />
        </Paper>
      )}
      {isOpen && searchData && searchData.documents.length > 0 && (
        <Paper
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: 300,
            overflow: "auto",
            mt: 1,
            boxShadow: 3,
          }}
        >
          <List dense>
            {searchData.documents.map((item: any, index: number) => (
              <ListItem
                key={index}
                onClick={() => handleItemClick(item)}
                sx={{
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                <ListItemText
                  primary={item.title || item.name || "Без названия"}
                  secondary={item.description || item.topic || ""}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      {isOpen && searchLoading && (
        <Paper
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            mt: 1,
            boxShadow: 3,
            p: 2,
          }}
        >
          <ListItemText primary="Загрузка..." />
        </Paper>
      )}
      {isOpen && searchError && (
        <Paper
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            mt: 1,
            boxShadow: 3,
            p: 2,
          }}
        >
          <ListItemText primary="Ошибка загрузки" />
        </Paper>
      )}
    </Box>
  );
};
